import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Tabs,
  Tab,
  TableContainer,
  TablePagination,
} from "@mui/material";

import DeliveryLogDialog from "./DeliveryLogDialog";

const DeliveryTransactionDashboard = () => {
  const [shops, setShops] = useState([]);
  // const [selectedShop, setSelectedShop] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [routes, setRoute] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDialog, setOpenDialog] = useState(false);
  const [editData, setEditData] = useState(null);

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchRoutes();
  }, []);
  const fetchRoutes = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/routes`);
      if (response.ok) {
        const data = await response.json();
        setRoute(data);
        console.log("routes data is ....", data);
        if (data.length > 0) {
          setSelectedRoute(data[0]._id);
        }
      } else {
        console.error("Error fetching routes");
      }
    } catch (error) {
      console.log("Error fetching routes", error);
    }
  };
  // const fetchShops = async () => {
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_URL}/shops`);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setShops(data);
  //       if (data.length > 0) {
  //         setSelectedShop(data[0]._id);
  //       }
  //     } else {
  //       console.error("Failed to fetch shops.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching shops:", error);
  //   }
  // };
  const fetchDeliveryLogs = async () => {
    try {
      const params = new URLSearchParams();
      // if (selectedShop) params.set("shopId", selectedShop);
      if (selectedRoute) params.set("routeId", selectedRoute);
      if (startDate) params.set("startDate", startDate);
      if (endDate) params.set("endDate", endDate);

      const queryString = params.toString() ? `?${params.toString()}` : "";
      console.log("queryString is ", queryString);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/deliveries${queryString}`
      );
      console.log("Fetch Response:", response);
      if (response.ok) {
        const data = await response.json();
        console.log("Deliveries:", data);
        setTransactions(data);
      } else {
        console.error("Failed to fetch delivery logs.", await response.text());
      }
    } catch (error) {
      console.error("Error fetching delivery logs:", error);
    }
  };

  useEffect(() => {
    fetchDeliveryLogs();
  }, [selectedRoute, startDate, endDate]);

  const toISODate = (dateString, isEndDate = false) => {
    const date = new Date(dateString);

    const utcDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        isEndDate ? 23 : 0,
        isEndDate ? 59 : 0,
        isEndDate ? 59 : 0,
        isEndDate ? 999 : 0
      )
    );

    return utcDate.toISOString();
  };

  const handlePaymentCheckList = async () => {
    if (!selectedRoute) return alert("Please select a route.");
    if (!startDate || !endDate)
      return alert("Please select a start and end date.");

    const payload = {
      startDate: toISODate(startDate, false),
      endDate: toISODate(endDate, true),
      routeId: selectedRoute,
    };

    const endpoint = `${process.env.REACT_APP_API_URL}/generate-payment-checklist`;

    setLoadingInvoice(true);

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Invoice generation failed.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "paymentCheckList.html";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("Error generating or downloading invoices.");
    } finally {
      setLoadingInvoice(false);
    }
  };

  const handleGenerateInvoice = async () => {
    if (!selectedRoute) return alert("Please select a route.");
    if (!startDate || !endDate)
      return alert("Please select a start and end date.");

    const payload = {
      startDate: toISODate(startDate, false),
      endDate: toISODate(endDate, true),
      routeId: selectedRoute,
    };

    const endpoint = `${process.env.REACT_APP_API_URL}/generate-invoices-by-route`;

    setLoadingInvoice(true);
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Invoice generation failed.");
      }

      // Download ZIP directly
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "invoices.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("Error generating or downloading invoices.");
    } finally {
      setLoadingInvoice(false);
    }
  };

  // const handleTabChange = (_, newIndex) => {
  //   if (newIndex === 0) {
  //     setEndDate("");
  //     setStartDate("");
  //     setSelectedRoute("");
  //   }
  //   setEndDate("");
  //   setStartDate("");
  //   setSelectedShop("");
  //   setTabIndex(newIndex);
  // };
  const handleEdit = (log) => {
    setEditData(log);
    setOpenDialog(true);
  };
  const handleClose = () => {
    setOpenDialog(false);
    setEditData(null);
  };

  return (
    <Box padding={2}>
      {/* <Tabs value={tabIndex} onChange={handleTabChange} centered>
        <Tab label="By Shop" />
        <Tab label="By Route" />
      </Tabs> */}

      <Paper
        sx={{
          marginY: 2,
          padding: 2,
          display: "grid",
          gap: 2,
          gridTemplateColumns: "1fr 1fr auto auto auto",
        }}
      >
        {/* {tabIndex === 0 ? (
          <Select
            value={selectedShop}
            onChange={(e) => setSelectedShop(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Select Shop
            </MenuItem>
            {shops.map((shop) => (
              <MenuItem key={shop._id} value={shop._id}>
                {shop.name}
              </MenuItem>
            ))}
          </Select>
        ) :  */}

        <Select
          value={selectedRoute}
          onChange={(e) => setSelectedRoute(e.target.value)}
          fullWidth
        >
          <MenuItem value="" disabled>
            Select Route
          </MenuItem>
          {routes.map((route) => (
            <MenuItem key={route._id} value={route._id}>
              {route.routeName}
            </MenuItem>
          ))}
        </Select>

        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleGenerateInvoice}
          disabled={loadingInvoice || !selectedRoute}
        >
          {loadingInvoice ? "Generating..." : "Download Invoice"}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handlePaymentCheckList}
          disabled={loadingInvoice || !selectedRoute}
        >
          {loadingInvoice ? "Generating..." : "Download PaymentCheckList"}
        </Button>
      </Paper>

      <Paper sx={{ padding: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          {/* <Typography variant="h6" sx={{ marginBottom: 2 }}>
            Transactions for{" "}
            {selectedShop
              ? `Shop: ${
                  shops.find((shop) => shop._id === selectedShop)?.name ||
                  "Unknown"
                }`
              : selectedRoute
              ? `Route: ${
                  routes.find((route) => route._id === selectedRoute)
                    ?.routeName || "Unknown"
                }`
              : "All"}
          </Typography> */}
          <Button
            sx={{ marginBottom: 4 }}
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            Add DeliveryLog
          </Button>
        </Box>

        <TableContainer
          component={Paper}
          // sx={{ maxHeight: 400, overflow: "auto" }}
        >
          <Table stickyHeader>
            <TableHead sx={{ backgroundColor: "#1976d2" }}>
              <TableRow>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Date
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Shop
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Product Name
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  In
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Out
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Total Quantity
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Invoice Generated
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Total Price
                </TableCell>
                <TableCell sx={{ color: "black", fontWeight: "bold" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    Delivery not found
                  </TableCell>
                </TableRow>
              ) : (
                transactions
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((log) =>
                    log.items.map((item, index) => (
                      <TableRow key={`${log.date}-${index}`}>
                        {index === 0 && (
                          <>
                            <TableCell rowSpan={log.items.length}>
                              {new Date(log.date).toLocaleDateString("en-GB")}
                            </TableCell>
                            <TableCell rowSpan={log.items.length}>
                              {log.shopName}
                            </TableCell>
                          </>
                        )}
                        <TableCell>{item.productName}</TableCell>
                        <TableCell>{item.deliveryQuantity}</TableCell>
                        <TableCell>{item.withdrawalQuantity}</TableCell>
                        <TableCell>{item.totalQuantity}</TableCell>
                        <TableCell>
                          {item?.invoiceGenerated ? "Yes" : "No"}
                        </TableCell>
                        <TableCell>{item.totalPrice}</TableCell>
                        <TableCell>
                          <Button onClick={() => handleEdit(log)}>Edit</Button>
                        </TableCell>
                      </TableRow>
                    ))
                  )
              )}
            </TableBody>
          </Table>
          <DeliveryLogDialog
            open={openDialog}
            handleClose={handleClose}
            onSubmit={(data) => console.log("Submitted Data:", data)}
            editData={editData}
            fetchDeliveries={fetchDeliveryLogs}
          />
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={transactions.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
};

export default DeliveryTransactionDashboard;
